import React, { useMemo } from 'react';
import { TextField, TextFieldProps, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { EntitySchema, RelationshipSchema } from '../types';

export interface EntitySchemaRelationSelectorProps {
  value?: string; // relation.propertyName
  schema?: EntitySchema;
  disabled?: boolean;
  className?: string;
  textFieldProps?: Omit<TextFieldProps, 'variant'>;
  onChange?: (relation: RelationshipSchema | undefined) => void;
}

const EntitySchemaRelationSelector: React.FC<EntitySchemaRelationSelectorProps> =
  props => {
    const { value, schema, disabled, className, textFieldProps, onChange } =
      props;

    const relations = useMemo(() => schema?.relations || [], [schema]);

    const selected = useMemo(() => {
      return relations.find(relation => relation.propertyName === value);
    }, [value, relations]);

    return (
      <Autocomplete
        disabled={disabled}
        options={relations}
        className={className}
        value={selected || null}
        getOptionLabel={option => option.displayName}
        onChange={(_, value) => onChange?.(value || undefined)}
        renderOption={option => (
          <span>
            <Typography>{option.displayName}</Typography>
            <Typography variant='body2' color='textSecondary'>
              {option.target} ({option.type})
            </Typography>
          </span>
        )}
        renderInput={params => (
          <TextField
            {...params}
            fullWidth
            variant='outlined'
            label='Relationship Property'
            {...textFieldProps}
          />
        )}
      />
    );
  };

export default EntitySchemaRelationSelector;
